/* Skin Clinic — scroll reveal. Small, dependency-free, and safe to fail: content stays visible without it. */
(function () {
  var root = document.documentElement;
  if (root.classList.contains('shopify-design-mode')) return;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var sections = Array.prototype.slice
    .call(document.querySelectorAll('#MainContent > .shopify-section'))
    .slice(1)
    .filter(function (el) {
      // leave the main template section alone (sticky galleries, filters, cart)
      return !/__main$/.test(el.id);
    });

  if (!sections.length) return;

  root.classList.add('sc-reveal-ready');
  sections.forEach(function (el) {
    el.classList.add('sc-reveal');
  });

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.06, rootMargin: '0px 0px -6% 0px' }
  );

  sections.forEach(function (el) {
    observer.observe(el);
  });

  // safety net: never leave content hidden if the observer misbehaves
  window.setTimeout(function () {
    sections.forEach(function (el) {
      el.classList.add('is-visible');
    });
  }, 4000);
})();
